<template>
  <div>
    <div class="flex mt-2">
      <div>
        <button
          @click="main_page"
          class="mr-2 hover:bg-gray-400 px-4 py-1 rounded-lg"
        >
          EDIT PAGE
        </button>
      </div>
      <div v-for="(item, i) in breadcrumbs" :key="i">
        <v-icon>mdi-arrow-right</v-icon>
        <button
          @click="back(item.id)"
          class="mx-2 hover:bg-gray-400 px-4 py-1 rounded-lg"
        >
          {{ item.menu_name.toUpperCase() }}
        </button>
      </div>
    </div>
    <!-- <button>
      Add new
    </button> -->
    <!-- service_id:{{ $route.params.service_id }}, route.params:{{ $route.params }} -->
    <div class="md:my-10 text-center">
      <div class="md:mx-64" v-for="(item, i) in services" :key="i">
        <div>
          <v-btn color="primary" @click="to(item)" class="my-1 py-8 w-full">
            {{ item.menu_name }}
          </v-btn>
        </div>
      </div>
      <div v-if="edit_mode">
        <!-- <pre>
          {{ answers }}
        </pre> -->
        <div id="app" class="md:mx-10">
          <v-expansion-panels>
            <v-expansion-panel v-for="(a, i) in answers" :key="i">
              <!-- {{ a }} -->
              <v-expansion-panel-header>
                <span v-if="a.question">{{ a.question }}</span>
                <span v-else>Answer {{ i + 1 }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="flex justify-start mb-2">
                  <input
                    multiple
                    type="file"
                    ref="upload_input"
                    @change="upload_image($event, a)"
                    accept=".jpg, .png,.JPEG"
                  />
                </div>
                <ckeditor v-model="a.text" :config="editorConfig"></ckeditor>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="md:py-4">
          <div>
            <v-progress-linear
              v-if="indeterminate"
              color="yellow darken-2"
            ></v-progress-linear>
            <br />
          </div>
          <button
            @click="save"
            class="text-white bg-color-btn p-4 rounded-lg w-1/2 outline-none focus:outline-none"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import CKEditor from "ckeditor4-vue";
export default {
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      indeterminate: false,
      files: [],
      breadcrumbs: [],
      snackbar: false,
      snackbarText: "",
      edit_mode: false,
      services: [],
      answers: [],
      answer: "",
      editorConfig: {},
    };
  },
  mounted() {
    this.indeterminate = false;
  },
  watch: {
    "$route.params.service_id": {
      handler() {
        this.edit_mode = false;
        if (this.$route.params.service_id == "editpage-home") {
          this.get_root_services();
        } else {
          this.get_service(this.$route.params.service_id);
        }
        this.get_breadcrumbs();
      },
      immediate: true,
    },
  },
  methods: {
    upload_image(e, a) {
      this.files = e.target.files;
      const formData = new FormData();
      for (const f of this.files) {
        formData.append("files", f);
      }
      axios.post("/edit_mode/upload_image", formData).then((res) => {
        for (const filename of res.data.filenames) {
          let link = `${axios.defaults.baseURL}/files/${filename}`;
          a.text += `<img src='${link}'>`;
          // this.$refs.upload_input.value = "";
        }
      });
    },
    to(item) {
      this.breadcrumbs = [
        {
          text: this.$route.meta.breadcrumbs_name,
          href: `http://localhost:8080/#${this.$route.path}`,
          disabled: false,
        },
      ];
      this.$router.push({
        name: "Edit Service",
        params: {
          service_id: item.id,
          use_faq: this.$route.params.use_faq,
        },
      });
    },
    get_root_services() {
      axios.get(`/menu/root_services_editmode`).then((res) => {
        this.services = res.data.services;
        // for (const item of this.edit_menus) {
        //   item.icon = require("@/assets/images/" + item.icon);
        // }
      });
    },
    get_service(item_id) {
      axios.get(`/menu/${item_id}/services`).then((res) => {
        this.services = res.data.services;
        // for (const item of this.edit_menus) {
        //   item.icon = require("@/assets/images/" + item.icon);
        // }
        if (this.services.length == 0) {
          this.edit_mode = true;
          this.get_answer(item_id);
        }
      });
    },
    get_breadcrumbs() {
      axios
        .get(`/menu/${this.$route.params.service_id}/breadcrumbs`)
        .then((res) => {
          this.breadcrumbs = res.data.breadcrumbs;
        });
    },
    get_answer(item_id) {
      this.answer = "";
      axios.get(`/menu/${item_id}/answers/edit_mode`).then((res) => {
        this.answers = res.data.answers.map((a) => ({ ...a, expanded: false }));
        if (res.data.answers.length > 0) {
          this.answer = res.data.answers[0].text;
        }
      });
    },
    back(e) {
      if (e == "-1") {
        e = "editpage-home";
      }
      this.$router.push(`/admin/edit_page/services/${e}`);
    },
    main_page() {
      this.$router.push(`/admin`);
    },
    save() {
      let data = {
        answers: this.answers,
      };
      axios.post(`/edit_mode/save`, data).then((res) => {
        this.indeterminate = true;
        if (res.data.status) {
          this.snackbar = true;
          this.snackbarText = res.data.message;
          this.indeterminate = false;
        } else {
          this.snackbar = true;
          this.snackbarText =
            "There seems to be something wrong, please try again!";
        }
      });
    },
  },
};
</script>

<style scoped>
.bg-color-btn {
  background-color: #1434a4;
}
.bg-color-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: black;
}
</style>
